export default {
  basicInformation: '基本情報',
  experience: '経験',
  skill: 'スキル',
  skillExperience: '職種・スキル',
  career: '経歴',
  workHistory: '職務経歴',
  education: '学歴',
  language: '言語',
  licenseAward: 'IT資格・表彰',
  preference: '希望条件',
  preview: 'プレビュー',
  edit: '項目を編集する',
  save: '保存する',
  messageHeader: 'この項目を削除しますか？',
  messageBody: '削除後に変更を保存してください。',
  buttonCancel: 'キャンセル',
  buttonAction: '削除',
  invalidFileSize: '最大ファイルサイズは5MBまでです。',
  invalidFileFormat: 'ファイルは画像（.jpg、.jpeg、.png）である必要があります。',
  currentWork: '現在の仕事',
  periodFrom: '開始年月',
  periodTo: '終了年月',
  workedInJapan: ' 日本国内勤務',
  jobTitle: '職種名',
  mostRecentEmployment: '直近の在籍企業',
  companyName: '会社名',
  companySize: '会社（従業員）の規模',
  employmentType: '雇用形態',
  workDetail: 'プロジェクト / 業務の詳細',
  workDetailPlaceholder: 'プロジェクト：ECサイトのバックエンド開発\n主な担当業務：Webアプリケーションのバックエンド開発を担当。Spring BootとKotlinでREST APIを構築し、決済システムや商品管理機能などを実装。AWSサービスを活用し、コスト削減とスケーラビリティ向上に貢献しました。',
  itSkills: '使用ITスキル',
  itSkillsPlaceholder: '言語：Java\nフレームワーク：Spring Boot\nクラウド：AWS\nデータベース：My SQL',
  roleSize: 'チームの規模 / 役割',
  roleSizePlaceholder: '開発チーム5名。バックエンド開発リーダーとして、API設計やDB設計を主導。',
  addProject: 'プロジェクトを追加',
  selectTemplate: 'テンプレートを選択',
  deleteProject: 'プロジェクトを削除する',
  experienceSection: {
    area: '経験分野'
  },
  careerSection: {
    workSummary: '経験のまとめ',
    workSummaryPlaceholder: '2020年から日本でITエンジニアとして就業し、要件定義から運用保守まで経験してきました。特に、JavaやAWSを活用したAPI開発やパフォーマンス改善を得意としています。',
    currentWorkStatus: '雇用状況',
    currency: '年収の通貨',
    annualIncome: '直近の年収',
    workDetail: '経歴の詳細',
    listIsAutomatically: 'リストは経歴の新しいもの順に自動的にソートされます。',
    required: 'Required'
  },
  introductionVideo: '自己紹介動画',
  uploadVideo: {
    text1: 'ファイルをアップロード',
    text2: '（50MBまで）'
  },
  invalidVideoSize: '最大ファイルサイズは50MBまでです。',
  invalidVideoFormat: 'ファイルはビデオ（.mp4、.mov、.webm）である必要があります。',
  shortVideo: '動画',
  shortVideoDescription: '簡単な自己紹介動画をアップすることで、企業に語学力をアピールできます',
  deleteVideo: '動画を削除',
  deleteMessage: '動画を削除しますか？',
  languageSection: {
    englishCertificate: '英語の資格・試験',
    otherLanguage: 'その他の言語',
    score: 'スコア',
    level: 'レベル'
  },
  profileVideo: '紹介動画',
  fiveSelectMaximum: '最大5個まで選択可能です',
  male: '男性',
  female: '女性',
  other: 'その他',
  uploadHeader: {
    header: 'プロフィール自動入力',
    body: 'レジュメをアップロードして簡単入力',
    button: 'アップロード'
  },
  dialogUpload: {
    header: 'レジュメをアップロードして簡単登録',
    body: 'ドラッグ&ドロップ or ファイルを選択',
    message: {
      message1: '“経歴や経験スキルについて詳細情報が書かれたレジュメをアップロードしてください',
      message2: ''
    },
    supportedFiles: {
      message: 'アップロード可能なファイル：pdf, doc, docx, rtf, txt',
      fileSize: '（容量：5MB）'
    },
    blankItems: '空欄の項目にのみ入力',
    overwriteItems: 'すべての項目を上書き'
  },
  uploadSuccess: {
    header: '自動入力が成功しました',
    body: '取り込んだ情報が正しいか確認、おかしな箇所があれば修正しましょう',
    checkbox: {
      item1: '残りの項目も追加入力することで企業の評価が高まります',
      item2: 'ページを離れる前には保存しましょう'
    }
  },
  emptyField: '未入力の項目があります',
  barometerAlertTooltip: 'プロフィールを充実させましょう!書類通過率が<span>約1.3倍</span>向上する傾向があります',
  workHistorySection: {
    add: '経験企業を追加',
    present: '現在'
  },
}
